import { useNavigate } from 'react-router-dom'
import { ArrowLeft } from 'lucide-react'
import { ProfitabilityDashboard } from '../components/ProfitabilityPerformance'

export default function ProfitabilityPerformance() {
  const navigate = useNavigate()

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
      <button
        type="button"
        onClick={() => navigate('/')}
        className="inline-flex items-center gap-2 rounded-lg border border-gray-300 bg-white px-3 py-1.5 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50 mb-4 transition-colors"
      >
        <ArrowLeft className="w-4 h-4" aria-hidden />
        Back to Hub
      </button>

      <div className="flex flex-wrap items-center justify-between gap-3 mb-6">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Profitability & Performance</h1>
          <p className="text-sm text-gray-500 mt-1 max-w-2xl">
            ProWorkflow snapshot — team performance and project profitability.
            Refreshed daily; admins can fetch a new snapshot on demand.
            Task price is the amount in each task’s ProWorkflow description.
          </p>
        </div>
        <span className="inline-flex items-center rounded-md bg-emerald-100 px-1.5 py-0.5 text-[10px] font-medium text-emerald-800">
          PWF snapshot
        </span>
      </div>

      <ProfitabilityDashboard />
    </div>
  )
}
